import { createContext } from 'react'

export type TechnicalInfoContextValue = {
  isSuperAdmin: boolean
  isResolved: boolean
  showTechnicalInfo: boolean
  setShowTechnicalInfo: (value: boolean) => void
}

export const TechnicalInfoContext = createContext<TechnicalInfoContextValue | null>(null)
